/*
 * @File: Do not edit
 * @Contact: lyhzyy0819@gmail.com
 * @License: (C)Copyright 2018-2024
 * @Modify Time: Do not edit
 * @Author: lyh
 * @Version: 1.0
 * @Description: 
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './styles/variables.css'
import './styles/reset.css'
import './styles/utilities.css'
// 引入Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 阻止双指缩放
document.addEventListener('gesturestart', function (event) {
  event.preventDefault();
}, { passive: false });

// 阻止双击缩放
let lastTouchEnd = 0;
document.addEventListener('touchend', function (event) {
  if (event.target instanceof Element && event.target.closest('[data-native-scroll]')) {
    lastTouchEnd = 0;
    return;
  }
  const now = (new Date()).getTime();
  if (now - lastTouchEnd <= 300) {
    event.preventDefault();
  }
  lastTouchEnd = now;
}, { passive: false });

createApp(App).use(router).use(ElementPlus).mount('#app')
